<template>
  <v-container fluid class="px-0">
    <v-expansion-panels v-model="searchPanel" class="mb-0" v-if="!loadDefault">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <v-row no-gutters>
            <v-col cols="4">
              Paieška
            </v-col>
          </v-row>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <form @keydown.enter.prevent="submit()">
            <v-row class="mb-3">
              <v-col cols="12" md="4">
                <el-autocomplete
                  :items="paieskaTipasList"
                  itemvalue="value"
                  itemtext="text"
                  label="Paieškos pavadinimas"
                  tooltip="Paieška. Savitarnos paieškos. Paieškos pavadinimas"
                  v-model="extraData.pai_tipas"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-text-field
                  label="Paieškos numeris"
                  tooltip="Paieška. Savitarnos paieškos. Paieškos numeris"
                  v-model="extraData.pai_numeris"
                />
              </v-col>
              <v-col cols="12" md="4">
                <el-autocomplete
                  :items="paieskaBusenaList"
                  itemvalue="value"
                  itemtext="text"
                  multiple
                  label="Paieškos būsena"
                  tooltip="Paieška. Savitarnos paieškos. Paieškos būsena"
                  v-model="extraData.pai_busenos"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-autocomplete
                  :items="paieskaApimtisList"
                  itemvalue="value"
                  itemtext="text"
                  label="Apimtis"
                  tooltip="Paieška. Savitarnos paieškos. Apimtis"
                  v-model="extraData.pai_apimtis"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-text-field
                  label="Paiešką užsakęs asmuo"
                  tooltip="Paieška. Savitarnos paieškos. Paiešką užsakęs asmuo"
                  v-model="extraData.pai_sukure"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-date-picker
                  label="Paieškos data nuo"
                  tooltip="Paieška. Savitarnos paieškos. Paieškos data nuo"
                  v-model="extraData.pai_sukurimo_data_nuo"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-date-picker
                  label="Paieškos data iki"
                  tooltip="Paieška. Savitarnos paieškos. Paieškos data iki"
                  v-model="extraData.pai_sukurimo_data_iki"
                />
              </v-col>
              <v-col cols="12" md="12">
                <el-text-field
                  label="Paieškos parametrai"
                  tooltip="Paieška. Savitarnos paieškos. Paieškos parametrai"
                  v-model="extraData.pai_parametrai"
                />
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="12">
                <el-button
                  primary
                  :loading="loading"
                  @click.native.stop="searchData()"
                >
                  Ieškoti
                </el-button>
                <el-button :loading="loading" @click.native="clearData()">
                  Išvalyti
                </el-button>
              </v-col>
            </v-row>
          </form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PaieskaRegistruotiSearch',
  props: {
    loading: Boolean,
  },
  data: () => ({
    searchPanel: null,
    loadDefault: null,
    mainData: {},
    extraData: {
      pai_tipas: null,
      pai_numeris: null,
      pai_busenos: [],
      pai_apimtis: null,
      pai_sukure: null,
      pai_sukurimo_data_nuo: null,
      pai_sukurimo_data_iki: null,
      pai_parametrai: null,
    },
  }),
  computed: {
    ...mapGetters(['searchParams']),
    isExpanded() {
      return this.searchPanel === 0
    },
    paieskaTipasList() {
      return [
        { value: 'juridinis', text: 'Pagal juridinį asmenį' },
        { value: 'fizinis', text: 'Pagal fizinį asmenį' },
        { value: 'turtas', text: 'Pagal turtą' },
        { value: 'kodas', text: 'Pagal identifikavimo kodą' },
      ]
    },
    paieskaBusenaList() {
      return [
        { value: 'laukia_patvirtinimo', text: 'Laukia patvirtinimo' },
        { value: 'tikrinama', text: 'Tikrinama' },
        { value: 'laukia_apmokejimo', text: 'Laukia apmokėjimo' },
        { value: 'vykdoma', text: 'Vykdoma' },
        { value: 'ivykdyta', text: 'Įvykdyta' },
        { value: 'neivykdyta', text: 'Neįvykdyta' },
        { value: 'atmesta', text: 'Atmesta' },
      ]
    },
    paieskaApimtisList() {
      return [
        { value: 1, text: 'Sąrašas' },
        { value: 2, text: 'Patikra' },
        { value: 3, text: 'Išrašas' },
      ]
    },
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    if (this.searchParams && this.searchParams.route === this.$route.name) {
      this.mainData = this.searchParams.mainData
      this.extraData = this.searchParams.extraData
      this.searchPanel = this.searchParams.isExpanded ? 0 : null
    }
    this.searchData()
  },
  methods: {
    searchData() {
      let searchData = {
        ...this.extraData,
      }

      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        mainData: this.mainData,
        extraData: this.extraData,
        isExpanded: this.isExpanded,
      })

      this.$emit('search', searchData)
    },
    clearData() {
      this.extraData = {
        pai_tipas: null,
        pai_numeris: null,
        pai_busenos: [],
        pai_apimtis: null,
        pai_sukure: null,
        pai_sukurimo_data_nuo: null,
        pai_sukurimo_data_iki: null,
        pai_parametrai: null,
      }
    },
    submit() {
      this.searchData()
    },
  },
}
</script>
